import { z } from 'zod';

/**
 * An Account = a workspace/tenant. One business uses one account.
 * Pricing is per-account-per-seat, but data namespacing is per-account.
 */
export const AccountSchema = z.object({
  id: z.string().guid(),
  slug: z.string().min(2).max(40), // url-safe, used in routing
  name: z.string().min(1).max(120),
  industry: z.string().nullable(),
  size: z
    .enum(['1-10', '11-25', '26-50', '51-100', '101-250', '250+'])
    .nullable(),
  brandColor: z.string().default('#8B5CF6'),
  plan: z.enum(['trial', 'active']).default('trial'),
  trialEndsAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  createdBy: z.string().guid(),
});

export type Account = z.infer<typeof AccountSchema>;

/** Prices live in apps/api ENTRY_PRICING + apps/web lib/billing.ts. */
export const PLAN_LIMITS = {
  /** Free trial: 3 seats, 14 days, full features. */
  trial:  { seats: 3,  integrations: 25, aiCallsPerDay: 200 },
  /** Paid: seats from subscription quantity. Full access. */
  active: { seats: Infinity, integrations: 25, aiCallsPerDay: 10000 },
} as const;
